import React, { useEffect } from 'react';
import styles from './index.module.scss';
import ArticleMainBlock from '../../article_components/ArticleMainBlock';
import ArticleContentBlock from '../../article_components/ArticleContentBlock';

const ArticlePage = ({ contentData, path_to_folder }) => {
  // useEffect(() => {
  //   console.log('ArticlePage:', { contentData, path_to_folder });
  // }, [contentData, path_to_folder]);

  useEffect(() => {
    if (!contentData || !Array.isArray(contentData) || !path_to_folder) return;
    const base = path_to_folder.startsWith('http') ? path_to_folder : `https://${path_to_folder}`;
    const imageUrls = [];
    const blocks = contentData.filter((_, index) => index !== 0);
    blocks.forEach((block) => {
      const tag = block.boock_tag || block.block_tag;
      const content = block.block_content;
      if (!content || !Array.isArray(content)) return;
      if (tag === 'main_block') {
        content.forEach((el) => {
          if ((el.cotent_tag === 'img_or_video' || el.content_tag === 'img_or_video') && el.img_name && el.img_name !== 'none') {
            const cleaned = el.img_name.split('/').pop().split('\\').pop();
            imageUrls.push(`${base}${cleaned}`);
          }
        });
      } else if (tag === 'content_block') {
        content.forEach((el) => {
          if ((el.cotent_tag === 'images' || el.content_tag === 'images') && el.imgs_names && el.imgs_names !== 'none') {
            const names = el.imgs_names
              .split(',')
              .map((name) => name.trim().replace(/['"[\]]/g, '').split('/').pop().split('\\').pop())
              .filter((name) => name && name !== 'none');
            names.forEach((name) => imageUrls.push(`${base}${name}`));
          }
        });
      }
    });
  }, [contentData, path_to_folder]);

  const renderBlock = (el) => {
    if ((el.boock_tag === 'main_block' || el.block_tag === 'main_block')) {
      // console.log('ArticleMainBlock props:', { blockData: el, path_to_folder });
      return <ArticleMainBlock blockData={el} path_to_folder={path_to_folder} />;
    }
    if ((el.boock_tag === 'content_block' || el.block_tag === 'content_block')) {
      // console.log('ArticleContentBlock props:', { blockData: el, path_to_folder });
      return <ArticleContentBlock blockData={el} path_to_folder={path_to_folder} />;
    }
    return null;
  };

  if (!contentData || !Array.isArray(contentData)) {
    return null;
  }

  const blocksToRender = contentData
    .filter((block, index) => index !== 0)
    .map((block, index) => {
      const renderedBlock = renderBlock(block);
      return renderedBlock ? (
        <div key={index + 1} className={styles.blockWrapper}>
          {renderedBlock}
        </div>
      ) : null;
    })
    .filter((block) => block !== null);

  if (blocksToRender.length === 0) {
    return null;
  }

  return (
    <div className={styles.articlePage}>
      <div className={styles.blocksContainer}>{blocksToRender}</div>
    </div>
  );
};

export default ArticlePage;
